import { render } from "./whats-on-events.vue?vue&type=template&id=160664ab"
import script from "./whats-on-events.vue?vue&type=script&lang=js"
export * from "./whats-on-events.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__